import { cloneDeep } from 'lodash'

import { initialAgentState } from '~/features/agents/store'
import { initialChatbotState } from '~/features/chatbot/store'
import { initialConversationState } from '~/features/conversations/store'
import { initialOrganizationState } from '~/features/organizations/store'
import { initialSettingsState } from '~/features/settings/store'
import { initialUIElementsSessionState } from '~/features/ui/sessionStore'
import { initialUIElementsState } from '~/features/ui/store'
import { initialUserState } from '~/features/user/store'
import EStoreStateKeys from '~/models/store'

export const storeInitialValues = () => {
  return {
    [EStoreStateKeys.user]: cloneDeep(initialUserState),
    [EStoreStateKeys.settings]: cloneDeep(initialSettingsState),
    [EStoreStateKeys.chatbot]: cloneDeep(initialChatbotState),
    [EStoreStateKeys.conversation]: cloneDeep(initialConversationState),
    [EStoreStateKeys.organization]: cloneDeep(initialOrganizationState),
    [EStoreStateKeys.UIElements]: cloneDeep(initialUIElementsState),
  }
}

export const sessionStoreInitialValues = () => {
  return {
    [EStoreStateKeys.agent]: cloneDeep(initialAgentState),
    [EStoreStateKeys.UIElements]: cloneDeep(initialUIElementsSessionState),
  }
}
